import Booking from '@/models/booking'
import Passenger from '@/models/passenger'
import PassengerExtra from '@/models/passenger-extra'

import { BookingsMutationTypes } from './bookings'

export enum PassengerExtrasActionTypes {}

export enum PassengerExtrasMutationTypes {}

export interface State {
  passengerExtraEntities: {
    [id: number]: PassengerExtra
  }
  passengerExtraIds: number[]
}

const initialState: State = {
  passengerExtraEntities: {},
  passengerExtraIds: [],
}

export default {
  state: initialState,
  getters: {
    getPassengerExtrasByPassengerId(
      state: State,
    ): (passengerId: number) => PassengerExtra[] {
      return (passengerId: number) => {
        const ids = state.passengerExtraIds.filter(
          (id: number) =>
            state.passengerExtraEntities[id].passengerId === passengerId,
        )

        return ids.map((id: number) => state.passengerExtraEntities[id])
      }
    },
  },
  actions: {},
  mutations: {
    [BookingsMutationTypes.GetSuccess](state: State, booking: Booking) {
      const passengerExtraEntities: { [id: number]: PassengerExtra } = {}
      const passengerExtraIds = state.passengerExtraIds

      booking.passengers.forEach((passenger: Passenger) => {
        passenger.passengerExtras.forEach((passengerExtra: PassengerExtra) => {
          if (state.passengerExtraIds.indexOf(passengerExtra.id) < 0) {
            passengerExtraIds.push(passengerExtra.id)
          }

          passengerExtraEntities[passengerExtra.id] = passengerExtra
        })
      })

      state.passengerExtraEntities = {
        ...state.passengerExtraEntities,
        ...passengerExtraEntities,
      }

      state.passengerExtraIds = passengerExtraIds
    },
  },
}
